module.exports = __webpack_public_path__ + "img/heroimage.8ebe1b11.png";